import { Info } from "react-feather"
import React from 'react'
import { TeaserData } from './teaser'
import parse, { HTMLReactParserOptions, domToReact, DOMNode } from 'html-react-parser';
import { InfoBoxTeaserEntry} from '../helper/interfaces';
import { useLoggedRouter } from '../helper/useLoggedRouter';
import {AppTheme, LinkType} from "../helper/enums";
import {getInfoBoxImageUrl} from "../helper/images";
import CustomImage from "./ui/Image";
import { getExternalLinks, getLinkObjectFromTeaser, getSpecificLink } from "../helper/link";

export default function TeaserInfoBox(data: TeaserData) {
  const teaser = data.teaser as InfoBoxTeaserEntry;
  const [routerPush] = useLoggedRouter();

  const options: HTMLReactParserOptions = {
    replace: domNode => {
      if ('attribs' in domNode && domNode?.attribs) {        
        const internalNavigate = async (e ,id) => {
          e.stopPropagation();
          e.preventDefault();
      
          await routerPush(`/article/${encodeURIComponent(id)}`);
        }

        const internalNavigateRessort = async (e, id) => {
          e.stopPropagation();
          e.preventDefault();
      
          await routerPush(`/ressort/${encodeURIComponent(id)}`);
        };
      
        if (domNode?.attribs?.href) {
          if(domNode.attribs.href.startsWith("detail:")) {
            const articleId = domNode.attribs.href.split(":")[1]
            return <a
                id={`a-internal-article-${articleId}`}
                href={`/article/${articleId}`}
                key={`teaser-link-${articleId}`}
                onClick={(e) => { internalNavigate(e, articleId) }}
              >
                {domToReact(domNode.children as DOMNode[], options)}
              </a>
          }
          else if(domNode.attribs.href.startsWith("ressort:")) {
            const ressortId = domNode.attribs.href.split(":")[1]
            return <a
                id={`a-internal-article-${ressortId}`}
                href={`/article/${ressortId}`}
                key={`teaser-link-${ressortId}`}
                onClick={(e) => { internalNavigateRessort(e, ressortId) }}
              >
                {domToReact(domNode.children as DOMNode[], options)}
              </a>
          }
          else if (domNode && domNode.attribs.href) {
            domNode.attribs.target = "_blank"
          }
        }
      }
    }
  };

  const getWebsiteDomain = (url: string) => {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname;
    } catch (error) {
      return url;
    }
  }

  const image = teaser?.images ? teaser.images[0] : null;
  const imageUrl = image && getInfoBoxImageUrl(image);

  const linkObject = getLinkObjectFromTeaser(teaser);
  const contactLink = getSpecificLink(teaser.links, LinkType.Contact);
  const externalLinks = getExternalLinks(teaser);

  return <React.Fragment>
    {teaser.showHrLines && <hr className="infobox-hr"></hr>}
    <div className="infobox">
      {process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn && <span className="infobox__icon-wrapper"><Info /></span>}
      {teaser.title && <p className="infobox-title">{teaser.title}</p>}
      <div className="infobox-content">
        {imageUrl &&
          <div className="infobox-image-wrapper w-full sm:w-1/2">
            <div className="infobox-image">
              <CustomImage
                key={`image-${image.id}-url${imageUrl}`}
                src={imageUrl}
                alt={image.subline}
                fill
                objectFit="contain"
              />
            </div>
            {(image.credit) &&
              <div className="infobox-image-meta">
                <span className="infobox-image-meta-credit"> &copy; {image.credit}</span>
              </div>
            }
          </div>
        }
        <div className="infobox__body">
          {teaser?.body && parse(teaser?.body, options)}
        </div>
        {(contactLink || (externalLinks && externalLinks.length > 0)) && (
          <div className="infobox__urls">
            {contactLink &&
              <a key={`contact-link`} href={`mailto:${contactLink}`} target="_blank" rel="noreferrer" className="infobox__url">              
                  <>
                  <span className={`infobox__url__icon icon-senden`}></span>E-Mail
                  </>
              </a>
            }
            {externalLinks?.map((entry,i) => 
              <a key={`external-link-${i}`} href={entry} target="_blank" rel="noreferrer" className="infobox__url">
                {!entry.includes("facebook") && !entry.includes("instagram") && (
                  <>
                  <span className={`infobox__url__icon icon-website`}></span> {getWebsiteDomain(entry)}
                  </>
                )}
                {entry.includes("instagram") && (
                  <>
                  <span className={`infobox__url__icon icon-instagram`}></span> Instagram
                  </>
                )}
                {entry.includes("facebook") && (
                  <>
                  <span className={`infobox__url__icon icon-facebook`}></span> Facebook
                  </>
                )}
              </a>
            )}
          </div>
        )}
      </div>
      <div className="clear-left"></div>
    </div>
  </React.Fragment>
}